// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"196":"92f91148","216":"c5d0e129","583":"aae981d4"}[chunkId] + ".chunk.js";
};